import Splide from "@splidejs/splide";

export const apartmentSliderInit = () => {
  const apartmentSliders = document.querySelectorAll('.apartment-slider');

  if(apartmentSliders) {
    apartmentSliders.forEach((item) => {
      const apartmentSlider = new Splide(item, {
        type: 'carousel',
        perPage: 1,
			  perMove: 1,
        pagination: false,
			  gap: '24px',
        autoplay: true,
        rewind: true,
        speed: 600,
        mediaQuery: 'min',
        breakpoints: {
          1025: {
            perPage: 3,
			      gap: '30px'
          },
          620: {
            perPage: 2,
			      gap: '24px'
          },
        }
      });

      apartmentSlider.mount();
    });
  }
}